import { useMutation, useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/Store';
import { useRequestSections } from '../../../api/request';

type useHistoryProps = {
  question_key: string;
};

type auditTrailProps = {
  question_id: number;
  asset_id: number;
  parent_submission_id: number;
};

const useHistory = (questionKey: useHistoryProps) => {
  const dispatch = useDispatch();
  const contextId = useSelector(
    (state: RootState) => state.contextId.contextId
  );
  const { History } = useRequestSections();
  const {
    data: history,
    isLoading: isHistoryLoading,
    isFetching: isHistoryFetching,
    refetch,
    error: historyError,
  } = useQuery({
    queryKey: ['viewHistory', contextId],
    queryFn: async () => {
      const response = await History?.getHistory(contextId, questionKey);
      return response?.data;
    },
    enabled: !!contextId,
    refetchOnWindowFocus: false,
    retry: 3,
  });

  const {
    mutateAsync: getAuditTrail,
    isPending: isAuditTrailPending,
    error: auditTrailError,
    isSuccess: successfulAuditTrail,
    data: auditTrailData,
  } = useMutation({
    mutationFn: async (param: auditTrailProps) => {
      const response = await History?.getHistoryTrail(contextId, param);

      return response?.data;
    },
  });

  return {
    history,
    isHistoryLoading,
    isHistoryFetching,
    refetch,
    historyError,

    getAuditTrail,
    auditTrailData,
    auditTrailError,
    isAuditTrailPending,
    successfulAuditTrail,
  };
};

export default useHistory;
